import { datasetSchema } from './../../../../../server/api/dataset/model/dataset-model';
import * as _ from "lodash";
import * as moment from "moment";
import { stringList } from 'aws-sdk/clients/datapipeline';
export class ReportPageComponent implements ng.IComponentOptions {
  public controller: any = ReportController;
  public template: string = /*html*/`
  <!-- <h2>{{$ctrl.titles[$ctrl.type]||"Summary Dataset"}}<button class="btn btn-primary pull-right" ng-click="$ctrl.refresh()">Refresh</button></h2> -->
  <h1 class="text-center" ng-show="$ctrl.loading"><i class="fa fa-fw fa-spin fa-spinner"></i></h1>
  <table class="table table-hover table-striped" ng-hide="$ctrl.loading||$ctrl.type">
  <tr><td>Total Datasets</td><td>{{$ctrl.reports.total}}</td></tr>
  <tr><td>Total Datasets By Ministry</td><td><p ng-repeat="ministry in $ctrl.reports.byministry">{{ministry._id.ministry.display_name||'Others'}}: {{ministry.count}}</p></td></tr>
  <tr><td>Total Datasets By Agency</td><td><p ng-repeat="agency in $ctrl.reports.byagency">{{agency._id.agency.display_name||'Others'}}: {{agency.count}}</p></td></tr>
  <tr><td>Total Datasets By Day</td><td>Today: {{$ctrl.reports.today}}<br>This Week: {{$ctrl.reports.thisWeek}}<br>This Month: {{$ctrl.reports.thisMonth}}</td></tr>
  <tr>
    <td>Bad Quality Datasets</td>
    <td>
      <p><strong>Ministry</strong></p>
      <p ng-repeat="ministry in $ctrl.reports.quality.byministry">{{ministry._id.ministry.display_name||'Others'}}: {{ministry.count}}</p>
      <p><strong>Agency</strong></p>
      <p ng-repeat="agency in $ctrl.reports.quality.byagency">{{agency._id.agency.display_name||'Others'}}: {{agency.count}}</p>
    </td>
  </tr>
  <tr><td>Active Ministry</td><td><p ng-repeat="org in $ctrl.reports.activeMinistry|orderBy: 'count'">{{org._id.ministry.display_name}}</p></td></tr>
  <tr><td>Active Agency</td><td><p ng-repeat="org in $ctrl.reports.activeAgency|orderBy: 'count'">{{org._id.agency.display_name}}</p></td></tr>
  <tr><td>Total User Uploading</td><td>{{$ctrl.reports.userAction.upload}}</td></tr>
  <tr><td>Total User Downloading</td><td>{{$ctrl.reports.userAction.download}}</td></tr>
  <div class="pull-right date-range" ng-show="$ctrl.type && ['1', '4', '5', '6'].indexOf($ctrl.type) === -1">
  Data Uploaded&nbsp; <input type="text" ng-model="$ctrl.range.startDate" ng-change="$ctrl.refresh()" class="form-control" uib-datepicker-popup ng-model="dt" is-open="popup1.opened" ng-focus="popup1.opened=true" close-text="Close" placeholder="Start Date" />
  &nbsp;to&nbsp; <input type="text" ng-model="$ctrl.range.endDate" ng-change="$ctrl.refresh()" class="form-control" uib-datepicker-popup ng-model="dt" is-open="popup2.opened" ng-focus="popup2.opened=true" close-text="Close" placeholder="End Date" />
  </div>
  </table>
  <div class="row" ng-show="$ctrl.type==='1'&&!$ctrl.loading">
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedAgency" required name="agency" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Agency" allow-clear="true">
      <span ng-bind="$select.selected.display_name"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.agencies | filter: $select.search)">
      <span ng-bind="item.display_name"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
    <input type="text" ng-model="$ctrl.monthRange.start" ng-change="$ctrl.refresh()" class="form-control" uib-datepicker-popup="MMM, yyyy" datepicker-options="$ctrl.dpOption" is-open="popup1.opened" ng-focus="popup1.opened=true" close-text="Close" placeholder="Start Date" />
  </div>
  <div class="col-md-3">
    <input type="text" ng-model="$ctrl.monthRange.end" ng-change="$ctrl.refresh()" class="form-control" uib-datepicker-popup="MMM, yyyy" datepicker-options="$ctrl.dpOption" is-open="popup2.opened" ng-focus="popup2.opened=true" close-text="Close" placeholder="End Date (Now)" />
  </div>
  <div class="col-md-3">
  <button type="button" class="btn btn-default" ng-click="$ctrl.download('1')"><i class="fa fa-fw fa-download"></i>Download</button>
  </div>
  <div class="col-xs-12" ng-hide="$ctrl.byCategory.length">No report found</div>
  <table class="table table-hover table-striped" ng-show="$ctrl.byCategory.length">
    <thead>
      <tr>
        <th>Ministry/Agency</th>
        <th class="text-center" ng-repeat="cat in $ctrl.categories">{{cat.code}}</th>
        <th class="text-center">Total</th>
      </tr>
    </thead>
    <tbody>
    <tr ng-repeat-start="report in $ctrl.byCategory">
      <td style="font-weight:600">{{report.agency?report.agency.display_name:report.ministry.display_name}}</td>
      <td style="font-weight:600" class="text-right" ng-repeat="cat in $ctrl.categories">{{report.total[cat.code]}}</td>
      <td style="font-weight:600" class="text-right">{{$ctrl.getSum(report.total)}}</td>
    </tr>
    <tr ng-repeat-end ng-repeat="r in report.stats">
      <td>{{r.datatype}}</td>
      <td class="text-right" ng-repeat="cat in $ctrl.categories">{{$ctrl.getCount(r.stats, cat.code)}}</td>
      <td class="text-right">{{r.total}}</td>
    </tr>
    </tbody>
  </table>
  </div>
  <table class="table table-hover table-striped text-center" ng-show="$ctrl.type==='2'">
  <thead>
  <tr>
  <th rowspan="2">No.</th>
  <th rowspan="2">Ministry/Agency</th>
  <th rowspan="2">Upload</th>
  <th rowspan="2">Failed Proccess</th>
  <th colspan="2" class="text-center">Output Datasets</th>
  </tr>
  <tr>
  <th>Share to Agency</th>
  <th>Share to Public</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="report in $ctrl.report2">
    <td>{{$index + 1}}</td>
    <td>{{report.group.display_name}}</td>
    <td>{{report.count}}</td>
    <td>{{report.bad}}</td>
    <td>{{report.internal}}</td>
    <td>{{report.public}}</td>
  </tr>
  </tbody>
  <tfooter>
    <tr>
      <th></th>
      <th class="text-right">Total</th>
      <th class="text-center">{{$ctrl.getTotalCount($ctrl.report2, "count")}}</th>
      <th class="text-center">{{$ctrl.getTotalCount($ctrl.report2, "bad")}}</th>
      <th class="text-center">{{$ctrl.getTotalCount($ctrl.report2, "internal")}}</th>
      <th class="text-center">{{$ctrl.getTotalCount($ctrl.report2, "public")}}</th>
    </tr>
  </tfooter>
  </table>
  <table class="table table-hover table-striped text-center" ng-show="$ctrl.type==='3'">
  <thead>
  <th>No.</th>
  <th>Dataset Name</th>
  <th>Category</th>
  <th>Agency</th>
  <th>Preview</th>
  <th>Download</th>
  <th>Total</th>
  </thead>
  <tbody>
  <tr ng-repeat="report in $ctrl.report3">
  <td>{{$index + 1}}</td>
  <td>{{report.display_name}}</td>
  <td>{{report.datatype.category}}</td>
  <td>{{report.agency?report.agency.code:report.ministry.code}}</td>
  <td>{{report.views}}</td>
  <td>{{report.downloads}}</td>
  <td>{{report.views+report.downloads}}</td>
  </tr>
  </tbody>
  <tfooter>
    <tr>
      <th></th>
      <th></th>
      <th></th>
      <th class="text-right">Total</th>
      <th class="text-center">{{a=$ctrl.getTotalCount($ctrl.report3, "views")}}</th>
      <th class="text-center">{{b=$ctrl.getTotalCount($ctrl.report3, "downloads")}}</th>
      <th class="text-center">{{a+b}}</th>
    </tr>
  </tfooter>
  </table>
  <div class="row" ng-show="$ctrl.type === '4'">
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedCategory" required name="category" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Category" allow-clear="true">
      <span ng-bind="$select.selected.name"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.categories | filter: $select.search)">
      <span ng-bind="item.name"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedAgency" required name="agency" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Agency" allow-clear="true">
      <span ng-bind="$select.selected.display_name"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.agencies | filter: $select.search)">
      <span ng-bind="item.display_name"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedYear" required name="year" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Year">
      <span ng-bind="$select.selected"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.years | filter: $select.search)">
      <span ng-bind="item"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
  <button type="button" class="btn btn-default" ng-click="$ctrl.download('4')"><i class="fa fa-fw fa-download"></i>Download</button>
  </div>
  <div class="col-xs-12" style="position:relative">
    <div id="table4" style="margin-top:8px"></div>
  </div>
  </div>
  <div class="row" ng-show="$ctrl.type === '5'">
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedAgency" required name="agency" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Agency" allow-clear="true">
      <span ng-bind="$select.selected.display_name"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.agencies | filter: $select.search)">
      <span ng-bind="item.display_name"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedMonth" required name="month" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Month"  allow-clear="true" >
      <span ng-bind="$select.selected"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.monthList | filter: $select.search)">
      <span ng-bind="item"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedYear" required name="year" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Year">
      <span ng-bind="$select.selected"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.years | filter: $select.search)">
      <span ng-bind="item"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
  <button type="button" class="btn btn-default" ng-click="$ctrl.download('5')"><i class="fa fa-fw fa-download"></i>Download</button>
  </div>
  <div class="col-xs-12" style="overflow:scroll">
  <table class="table table-hover table-striped text-center">
    <thead>
      <th>Date</th>
      <th>Action</th>
      <th>Category</th>
      <th>Dataset Name</th>
      <th>Agency</th>
      <th>By User</th>
    </head>
    <tbody>
      <tr ng-repeat="report in $ctrl.report5">
        <td>{{report.createdOn | date: 'd-MMM-yyyy'}}</td>
        <td>{{$ctrl.actionMap[report.action]}}</td>
        <td>{{report.subject.id.category}}</td>
        <td class="text-left">{{report.subject.id.display_name}}</td>
        <td>{{report.subject.id.agency?report.subject.id.agency.code:report.subject.id.ministry.code}}</td>
        <td>{{$ctrl.getUser(report)}}</td>
      </tr>
    </tbody>
  </table>
  </div>
  </div>
  <div class="row" ng-show="$ctrl.type === '6'">
  <div class="col-md-3">
  <ui-select ng-model="$ctrl.selectedYear" required name="year" ng-change="$ctrl.refresh()">
    <ui-select-match placeholder="Select Year">
      <span ng-bind="$select.selected"></span>
    </ui-select-match>
    <ui-select-choices repeat="item in ($ctrl.years | filter: $select.search)">
      <span ng-bind="item"></span>
    </ui-select-choices>
  </ui-select>
  </div>
  <div class="col-md-3">
  <button type="button" class="btn btn-default" ng-click="$ctrl.download('6')"><i class="fa fa-fw fa-download"></i>Download</button>
  </div>
  <div class="col-xs-12" style="overflow:scroll">
  <table class="table table-hover table-striped text-center">
    <thead>
      <tr>
      <th rowspan="2">Year {{$ctrl.selectedYear}}</th>
      <th rowspan="2">Data Champion</th>
      <th colspan="2">Public Users</th>
      <th rowspan="2">Total</th>
      </tr>
      <tr>
      <th>Individual</th>
      <th>Organisation</th>
      </tr>
    </head>
    <tbody>
      <tr ng-repeat="report in $ctrl.report6.data">
        <td>{{$ctrl.monthList[report.month - 1]}}</td>
        <td class="text-center pointer" ng-click="$ctrl.deepView(report.month, 'internal')"><span class="numPad">{{report.internal}}</span></td>
        <td class="text-center pointer" ng-click="$ctrl.deepView(report.month, 'external')"><span class="numPad">{{report.external}}</span></td>
        <td class="text-center pointer" ng-click="$ctrl.deepView(report.month, 'external_org')"><span class="numPad">{{report.external_org}}</span></td>
        <td class="text-center"><span>{{report.total}}</td>
      </tr>
      <tr>
        <th class="text-center">Total</th>
        <th class="text-center"><span class="numPad">{{$ctrl.report6.total.internal}}</span></th>
        <th class="text-center"><span class="numPad">{{$ctrl.report6.total.external}}</span></th>
        <th class="text-center"><span class="numPad">{{$ctrl.report6.total.external_org}}</span></th>
        <th class="text-center"><span class="numPad">{{$ctrl.report6.total.total}}</span></th>
      </tr>
    </tbody>
  </table>
  </div>
  </div>
  `
  ;
}

export class ReportController {
  public static $inject: Array<string> = ["$http", "$stateParams", "$scope", "$window", "$uibModal"]
  public reports: any;
  public loading: boolean = false;
  public byCategory: any;
  public categories: Array<any>;
  public type: string;
  public titles: any;
  public range: {startDate?: Date, endDate?: Date};
  public monthRange: {start?: Date, end?: Date};
  public report2: Array<any>;
  public report3: Array<any>;
  public report4: {data:Array<any>, total: number[]};
  public report5: Array<any>;
  public report6: Array<any>;
  public selectedYear: number;
  public selectedMonth: string;
  public monthList: string[];
  public years: number[];
  public agencies: any;
  public selectedCategory: any;
  public selectedAgency: any;
  public totalCount: number;
  public actionMap: any;
  public dpOption: any;
  public reverse: boolean;

  constructor(private $http: ng.IHttpService, private $stateParams: ng.ui.IStateParamsService, private $scope: ng.IScope, private $window: ng.IWindowService, private $uibModal:ng.ui.bootstrap.IModalService) {
    $scope.$emit("adminPageChange",{name:"report"});
    this.type = $stateParams.type;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.titles = {
      '1': "Summary Dataset by Agencies vs Category",
      '2': "Dataset Status By Agencies",
      '3': "Dataset Popularity",
      '4': 'Statistic Download Report',
      '5': 'Dataset Activity Stream',
      '6': 'User Registration Tracking'
    }
    this.range = {endDate: new Date()};
    this.monthRange = {
      start: moment().subtract(1, 'year').toDate()
    }
    this.actionMap = {
      'addDataset': 'Upload',
      'downloadDatasetFile': 'Download',
      'updateDataset': 'Edit',
      'deleteDataset': 'Delete'
    }
    this.monthList = moment.months();
    if (this.type === '5') {
      this.selectedMonth = null;
      this.selectedYear = moment().year();
    }
    else {
      this.selectedYear = moment().year() - 1
      this.selectedMonth = this.monthList[moment().month() - 1];
    }
    this.years = [this.selectedYear - 2, this.selectedYear - 1, this.selectedYear, this.selectedYear + 1]
    this.dpOption = {
      minMode:"month"
    }
    this.reverse = true
    this.refresh();
  }
  public refresh() {
    let query = "";
    if (this.range.startDate)
      query += `start=${moment(this.range.startDate).format("YYYY-MM-DD")}&`
    if (this.range.endDate)
      query += `end=${moment(this.range.endDate).format("YYYY-MM-DD")}`
    this.loading = true;
    let categories = this.$http.get(`${BASE}/classification?type=category`).then((d:any) => this.categories = d.data)
    if (!this.type)
      this.$http.get(`${BASE}/api/report`).then((d:any) => {
        this.reports = d.data;
        this.loading = false;
      })
    if (this.type === '1') {
      let url = `${BASE}/api/report1?start=${moment(this.monthRange.start).format('YYYY-MM-DD')}&end=${moment(this.monthRange.end).format('YYYY-MM-DD')}`
      if (this.selectedAgency) {
        url += `&agency=${this.selectedAgency._id}`
      }
      this.$http.get(url)
      .then((d:any) => {
        this.loading = false;
        this.byCategory = d.data
      })
      this.getAgencies()
    }
    if (this.type === '2') {
      this.$http.get(`${BASE}/api/report2?${query}`)
      .then((d:any) => {
        this.loading = false;
        this.report2 = d.data;
      })
    }
    if (this.type === '3') {
      this.loading = false;
      this.$http.get(`${BASE}/api/report3?${query}`)
      .then((d:any) => {
        this.loading = false;
        this.report3 = d.data;
      })
    }
    if (this.type === '4') {
      this.loading = false;
      let url = `${BASE}/api/activity/download?year=${this.selectedYear}`
      if (this.selectedAgency) {
        url += `&agency=${this.selectedAgency._id}`
      }
      if (this.selectedCategory) {
        url += `&category=${this.selectedCategory.code}`
      }
      this.$http.get(url)
      .then((d:any) => {
        this.report4 = d.data;
        const _this = this;
        const totalCount = _.sum(this.report4.total)
        google.charts.load('current', {'packages':['table']});
        google.charts.setOnLoadCallback(function() {
          const data = new google.visualization.DataTable();
          data.addColumn('string', 'Category');
          data.addColumn('string', 'Agency');
          data.addColumn('string', 'Statistic');
          _.each(moment.months(), (m) => data.addColumn('number', m))
          data.addColumn('number', 'Total')
          data.addRows([
            ..._.map(d.data.data, (d:any) => [_.get(d, 'subject.category', ''), _.get(d, 'subject.agency.code', _.get(d, 'subject.ministry.code', '')), _.get(d, 'subject.display_name'), ...d.stat, d.total]),
            ['Total', '', '',  ...d.data.total, totalCount]
          ]);

          const table = new google.visualization.Table(document.getElementById('table4'));
          table.clearChart();
          table.draw(data, {showRowNumber: false, frozenColumns: 3, width: '100%', height: '530px', cssClassNames: {tableCell: 'table-cell', headerCell: 'header-cell', tableRow: 'table-row', OddTableRow: 'odd-table-row'}});
          _this.loading = false
        });
      })
      this.getAgencies()
    }
    if (this.type === '5') {
      this.loading = false;
      let url;
      if (this.monthList.indexOf(this.selectedMonth) <= 0) {
        url = `${BASE}/api/activity/datasetReport?year=${this.selectedYear}`
      }
      else {
        url = `${BASE}/api/activity/datasetReport?month=${this.monthList.indexOf(this.selectedMonth)}&year=${this.selectedYear}`
      }
      if (this.selectedAgency) {
        url += `&agency=${this.selectedAgency._id}`
      }
      this.$http.get(url)
      .then((d:any) => {
        this.loading = false
        this.report5 = d.data;
      })
      this.getAgencies()
    }
    if (this.type === '6') {
      this.loading = false
      let url = `${BASE}/api/user/report?year=${this.selectedYear}`
      this.$http.get(url)
      .then((d:any) => {
        this.loading = false
        this.report6 = d.data;
      })
    }
  }
  public getTotal(category) {
    let total = 0;
    _.each(this.byCategory, (cate:any) => {
      total += cate.categories[category];
    })
    return total;
  }
  public getTotals() {
    return _.sumBy(this.byCategory, 'total')
  }
  public getTotalCount(collection, field) {
   return _.sumBy(collection, field);
  }
  public getAgencies() {
    Promise.all([
      this.$http.get(`${BASE}/api/agency?state=active`),
      this.$http.get(`${BASE}/api/ministry?state=active`)
    ])
    .then((d:any) => {
      this.agencies = _.union(d[0].data, d[1].data)
    })
  }
  public download(type) {
    let url;
    if (type === '1') {
      url = `${BASE}/api/report1?export=true&start=${moment(this.monthRange.start).format('YYYY-MM-DD')}&end=${moment(this.monthRange.end).format('YYYY-MM-DD')}`
      if (this.selectedAgency) {
        url += `&agency=${this.selectedAgency._id}`
      }
    }
    if (type === '4') {
      url = `${BASE}/api/activity/download?export=true&year=${this.selectedYear}`
      if (this.selectedAgency) {
        url += `&agency=${this.selectedAgency._id}`
      }
      if (this.selectedCategory) {
        url += `&category=${this.selectedCategory.code}`
      }
    }
    if (type === '5') {
      if (this.monthList.indexOf(this.selectedMonth) <= 0) {
        url = `${BASE}/api/activity/datasetReport?export=true&year=${this.selectedYear}`
      }
      else {  
        url = `${BASE}/api/activity/datasetReport?export=true&month=${this.monthList.indexOf(this.selectedMonth)}&year=${this.selectedYear}`
      }
      if (this.selectedAgency) {
        url += `&agency=${this.selectedAgency._id}`
      }
    }
    if (type === '6') {
      url = `${BASE}/api/user/report?export=true&year=${this.selectedYear}`
    }
    url += `&token=${localStorage.token}`
    this.$window.open(url, '_blank')
  }

  public getCount(stat, category) {
    const result:any = _.find(stat, {category:category})
    return result?result.count: 0
  }

  public getSum(counts) {
    return _.sum(_.values(counts))
  }

  public deepView(month: number, type: string) {
    this.$uibModal.open({
      component: 'ReportDetailModal',
      resolve: {
        type: () => type,
        month: () => month,
        year: () => this.selectedYear
      },
      size: 'lg'
    })
  }

  public getUser(report) {
    let output = _.get(report, 'user.fullname')
    if (report.agency || report.ministry) {
      if (report.agency)
        output += ` (${report.agency.code})`
      else 
        output += ` (${report.ministry.code})`
    }
    return output
  }
}
